import UserFeedback from './UserFeedback';

export default UserFeedback;